import React from 'react';
import Header from '../../components/Header/Header';
import Hero5 from '../../components/Hero5/Hero5';
import News from '../../components/News/News';
import Footer from '../../components/Footer/Footer';

const Page5 = () => {
  return (
    <div>
      <Header />
      <Hero5 />
      <News />
      <Footer />
    </div>
  );
};

export default Page5;
